<template>
    <v-tabs
            color="white"
            icons-and-text
    >
        <v-tabs-slider color="primary"></v-tabs-slider>

        <v-tab href="#user">
            {{$t('user.tab_account')}}
            <v-icon>face</v-icon>
        </v-tab>

        <v-tab href="#storage">
            {{$t('user.tab_storage')}}
            <v-icon>folder</v-icon>
        </v-tab>

        <v-tab-item value="user">

            <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-form id="profile_form" method="post" :action="profile_form.action" v-on:success="successSaveProfile" ref="profile_form">
                            <v-card flat>
                                <v-card-text>
                                    <v-container grid-list-md>
                                        <v-layout wrap>
                                            <v-flex xs12>
                                                <h2>Update profile</h2>
                                            </v-flex>

                                            <v-flex
                                                    xs12
                                                    md6
                                            >
                                                <v-text-field
                                                        v-model="profile_form.data.first_name"
                                                        name="first_name"
                                                        :label="$t('user.first_name')"
                                                        required
                                                        :error-messages="profile_form.errors.first_name"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex
                                                    xs12
                                                    md6
                                            >
                                                <v-text-field
                                                        v-model="profile_form.data.last_name"
                                                        name="last_name"
                                                        :label="$t('user.last_name')"
                                                        required
                                                        :error-messages="profile_form.errors.last_name"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex
                                                    xs12
                                                    md12
                                            >
                                                <v-text-field
                                                        v-model="profile_form.data.email"
                                                        :label="$t('user.email')"
                                                        readonly
                                                        disabled
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12>
                                                <v-text-field
                                                        v-model="profile_form.data.old_password"
                                                        name="old_password"
                                                        :label="$t('user.old_password')"
                                                        type="password"
                                                        :error-messages="profile_form.errors.old_password"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12>
                                                <v-text-field
                                                        v-model="profile_form.data.new_password"
                                                        name="new_password"
                                                        :label="$t('user.new_password')"
                                                        type="password"
                                                        :error-messages="profile_form.errors.new_password"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12>
                                                <v-text-field
                                                        v-model="profile_form.data.confirm_password"
                                                        name="confirm_password"
                                                        :label="$t('user.confirm_password')"
                                                        :rules="[profile_form.rules.confirm_password]"
                                                        type="password"
                                                        :error-messages="profile_form.errors.confirm_password"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions class="align-center justify-center">
                                    <v-btn
                                            color="primary"
                                            type="submit"
                                            ref="submit"
                                            :loading="profile_form.loading"
                                    >
                                        {{$t('action.save')}}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-flex>

<!--                    <v-flex sm6 md5>-->
<!--                        <v-card flat>-->
<!--                            <v-card-text>-->
<!--                                <v-container grid-list-md>-->
<!--                                    <v-layout wrap>-->
<!--                                        <v-flex xs12 class="align-center justify-center">-->
<!--                                            <h2>User storage</h2>-->

<!--                                            <div class="small">-->
<!--                                                <pie-chart :chart-data="pieDataCollection" :options="pieChartOptions"></pie-chart>-->
<!--                                            </div>-->
<!--                                        </v-flex>-->
<!--                                    </v-layout>-->
<!--                                </v-container>-->

<!--                            </v-card-text>-->
<!--                        </v-card>-->
<!--                    </v-flex>-->
                </v-layout>
            </v-container>


        </v-tab-item>

        <v-tab-item value="storage">
            <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex xs12 class="align-center justify-center">
                        <v-card flat>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12>
                                            <div class="small">
                                                <h2>{{$t('file_related.storage_limit')}}</h2>
                                                <p>{{remain_storage_desc}}</p>
                                                <pie-chart :chart-data="pieDataCollection" :options="pieChartOptions"></pie-chart>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

        </v-tab-item>
    </v-tabs>
</template>

<script>
    import PieChart from "~/utils/chartjs/PieChart";
    import LineChart from "~/utils/chartjs/LineChart";
    import RequestHandler from "~/utils/request-handler";
    import {UrlServices} from "~/utils/url-manager";
    import FormHandling from "~/utils/data/form-handling"
    import Utils from '~/utils';

    export default {
        name: "Details",
        components: {
            PieChart,
            LineChart
        },
        data() {
            return {
                profile_form: {
                    action: UrlServices.createUrl({name: 'api_user_save'}),
                    loading: false,
                    rules: {
                        confirm_password: value => {
                            return value == this.profile_form.data.new_password || this.$t('login.confirm_password_different')
                        },
                    },
                    data: {
                        last_name: null,
                        first_name: null,
                        email: null,
                        old_password: null,
                        new_password: null,
                        confirm_password: null
                    },
                    errors: {
                        last_name: null,
                        first_name: null,
                        old_password: null,
                        new_password: null,
                        confirm_password: null,
                    }
                },
                dataCollection: {},
                pieDataCollection: {},
                pieChartOptions: {
                    responsive: true,
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                let value = parseInt(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]) || 0;
                                let label = data.labels[tooltipItem.index];
                                let sum = 0;
                                let dataArr = data.datasets[0].data;
                                dataArr.map(data => {
                                    sum += parseInt(data);
                                });
                                return label + ': ' + Utils.getPercentageText(sum, value) + ' (' + Utils.getFileSizeText(value) + ')';
                            }
                        }
                    }
                },
                file_type_color: {
                    empty: '#DDD',
                    event_media: '#3366cc',
                    event_attachment: '#dc3912',
                    event_photo: '#ff9900',
                    event_img: '#109618',
                    payment_receipt: '#990099'
                },
                user_total_storage: 0,
                remain_storage_desc: ""
            }
        },
        mounted() {
            this.getUserData();

            new FormHandling(this, "profile_form", this.profile_form)
        },
        methods: {
            successSaveProfile(data) {
                let message = data['msg'];

                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: message,
                    timeout: 3000
                };

                this.profile_form.data.old_password = null;
                this.profile_form.data.new_password = null;
                this.profile_form.data.confirm_password = null;
            },

            getUserData() {
                let me = this;
                window.getApp.$emit('APP_START_LOADING');
                RequestHandler.Get(UrlServices.createUrl({name: 'api_user_get_info'}), {}, {
                    'success': function(data) {
                        let user_data = data;
                        me.profile_form.data.last_name = user_data.last_name;
                        me.profile_form.data.first_name = user_data.first_name;
                        me.profile_form.data.email = user_data.email;

                        let storage_usage = user_data.storage_usage;
                        let storage_limit = parseInt(storage_usage.storage_limit);
                        let storage_limit_text = me.$t('file_related.unlimited');
                        let total_used = parseInt(storage_usage.total_used);
                        let storage_by_type = storage_usage.storage_by_type;
                        let remain_storage = 0;

                        let pie_data = {
                            datasets: [{
                                data: [],
                                backgroundColor:[]
                            }],
                            labels: []
                        };

                        this.user_total_storage = parseInt(storage_usage);

                        if(storage_limit > 0){
                            storage_limit_text = Utils.getFileSizeText(storage_limit);
                            remain_storage = storage_limit - total_used;
                            if(remain_storage > 0){
                                pie_data.datasets[0].data.push(remain_storage);
                                pie_data.datasets[0].backgroundColor.push(me.file_type_color.empty);
                                pie_data.labels.push(me.$t('file_related.remain_storage'));
                            }
                        }

                        me.remain_storage_desc = me.$t('file_related.remain_storage_desc', {
                            'total_size': storage_limit_text,
                            'used_size': Utils.getFileSizeText(total_used)
                        });

                        _.each(storage_by_type, function(value, name){
                            if(value > 0){
                                pie_data.datasets[0].data.push(value);
                                pie_data.datasets[0].backgroundColor.push(me.file_type_color[name]);
                                pie_data.labels.push(me.$t('file_related.' + name));
                            }
                        });
                        me.pieDataCollection = pie_data;
                    },
                    'complete': function() {
                        window.getApp.$emit('APP_STOP_LOADING');
                    }
                });
            },
            getRandomInt () {
                return Math.floor(Math.random() * (50 - 5 + 1)) + 5
            }
        }
    }
</script>

<style scoped>
    .small {
        max-width: 400px;
        margin:  0 auto;
    }
</style>